export default __webpack_public_path__ + "static/media/116-5861-011_4310.a2fdc836.png";